export const SIGNIN = 'SIGNIN'; 
export const AUTHENTICATED = 'AUTHENTICATED';
export const SIGNOUT = 'SIGNOUT';
export const SIGNOUT_SUCCESS = 'SIGNOUT_SUCCESS'
export const SIGNUP = 'SIGNUP';
export const SIGNUP_SUCCESS = 'SIGNUP_SUCCESS'
export const SHOW_AUTH_MESSAGE = 'SHOW_AUTH_MESSAGE'
export const HIDE_AUTH_MESSAGE = 'HIDE_AUTH_MESSAGE'
export const SHOW_RESET_MESSAGE = 'SHOW_RESET_MESSAGE'
export const HIDE_RESET_MESSAGE = 'HIDE_RESET_MESSAGE'
export const SHOW_LOADING = 'SHOW_LOADING'
export const AUTH_TOKEN = 'auth_token'
export const FIRST_NAME = 'first_name'
export const LAST_NAME = 'last_name'
export const LN_ID = 'ln_id'
export const DEPT_ID = 'dept_id'
export const DEPT_DESCRIPTION = 'dept_description'
export const AVATAR = 'avatar'
export const ENDORSABLE = 'endorsable'
export const ROLE = 'role'
export const APPLICATION = 'application'
export const NAV_ROLE_SECTIONS = 'nav_role_sections'
export const PATH_ROLE_SECTIONS = 'path_role_sections'
export const SIGNIN_WITH_GOOGLE = 'SIGNIN_WITH_GOOGLE'
export const SIGNIN_WITH_GOOGLE_AUTHENTICATED = 'SIGNIN_WITH_GOOGLE_AUTHENTICATED'
export const SIGNIN_WITH_FACEBOOK = 'SIGNIN_WITH_FACEBOOK'
export const SIGNIN_WITH_FACEBOOK_AUTHENTICATED = 'SIGNIN_WITH_FACEBOOK_AUTHENTICATED'